import { sha256 } from '../../common/js/sha256';
import { getUserViewModelFromLocalStorage } from '../userApi';


/**
 * @description Мапа с короткими названиями, на названия операции в EggAfisha
 * @see https://egg.afisha.ru/operations - искать операции по значению в ключах
 * @enum {string} - строковые идентификаторы операций из EggAfisha
 * P.S: События по виджету кассы - касса отправляет сама из виджета
 */
const OPERATIONS = {
  // Подписка на email рассылку
  // Отправляем операцию при получении ответа от сервера при подписке пользователя на email рассылку
  'SUBSCRIBE': 'Website.Afisha.Daily.Subscribe',
  // Авторизация в RamblerID
  // Отправляем только при авторизации на сайте - получении пользователя
  'AUTH': 'Website.Afisha.Daily.AuthenticatedOnWebsite',
};

/**
 * @description Класс инкапсулирует логику отправки операций в EggAfisha
 * @see https://egg.afisha.ru/operations
 * @see https://docs.google.com/document/d/1UDIMPY8_tGFlXEotFKUgP8aFn9sUfhNj4qajgpK0G6I/edit#
 */
class MindBoxService {

  constructor() {
    // Запишем ссылку наш EE в класс
    this.ee = window.Daily.ee;
    // this.debug = true;
    // Если вдруг сломали - кинем error
    if (!this.ee) {
      throw new Error('Cant find Daily Event Emitter');
    }
    // Подпишемся на внешние события (авторизация, подписка на email)
    this._setListeners();
  }

  /**
   * @description Отправляет операцию в EggAfisha, а сервис Афишы в MindBox
   * @param operation {OPERATIONS}
   * @param payload {Object<string, any>}
   * @private
   */
  _send(operation, payload) {
    if (this.debug) {
      console.log('send operation', operation);
    }
    return window.EF.send('operation', { name: operation, body: payload });
  }

  /**
   * Подписываемся на события
   * @private
   */
  _setListeners() {
    // Подписываемся на событие авторизации пользователя
    this.ee.on('authorized', () => {
      // Отправляем операцию
      this.auth();
    });
    // Подписываемся на событие email подписки (Desktop/Mobile)
    this.ee.on('email-subscribe', (email, response) => {
      // Отправляем операцию о подписки на email
      this.emailSubscribe(email, response);
    });
  }

  /**
   * @description Собирает данные пользователя экспортированные из ramblerID
   * @private
   */
  _getPrivateUserInfo() {
    /**
     * @type {UserViewModel}
     */
    const userViewModel = getUserViewModelFromLocalStorage();
    const { email } = userViewModel;
    return { email };
  }

  /**
   * @description Возвращает объект с ramblerID кодированный в строку алгоритмом sha256
   * @returns {{ids: {ramblerID: (string|null)}}}
   * @private
   */
  _getRamblerIdUserInfo() {
    /**
     * @type {String}
     */
    const rid = window && window.rid;
    return {
      ids: {
        ramblerID: rid ? sha256(rid) : null,
      }
    };
  }

  /**
   * @description Посылаем операцию о email подписке
   * @param emailFromInput {String} - почта из инпута подписки
   * @param responseCallback
   * @see https://afisha.mindbox.ru/campaigns/7/operations/51/help
   */
  emailSubscribe(emailFromInput, responseCallback) {
    const user = this._getRamblerIdUserInfo();
    if (emailFromInput && emailFromInput !== '') {
      this._send(OPERATIONS.SUBSCRIBE, {
        customer: {
          email: emailFromInput,
          subscriptions: [{ pointOfContact: 'Email' }],
          ...user
        },
      }).then(responseCallback);
    } else {
      throw new Error('user email is empty or wrong type: ' + typeof emailFromInput);
    }
  }

  /**
   * @description Посылаем операцию авторизации пользователя, когда получили его данные из ID
   * @see https://afisha.mindbox.ru/campaigns/7/operations/48/help
   * @returns {Promise<*>}
   */
  auth() {
    const { email, phone } = this._getPrivateUserInfo();
    const user = this._getRamblerIdUserInfo();
    return this._send(OPERATIONS.AUTH, {
      customer: {
        email,
        mobilePhone: phone,
        ...user,
      }
    });
  }

}

const service = new MindBoxService();
export default service;



// WEBPACK FOOTER //
// ./daily/assets/id/services/mindbox.service.js